import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'app-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.css'],
  standalone: false
})
export class FilterDropdownComponent {
  @Input() filterToAdd: any[] = [];
  @Output() selectedFilterChange = new EventEmitter<any>();
  @Input() selectedFilter: any[] = [];
  dropdownOpen: boolean = false;
  searchQuery: string = '';
  public selectAllChecked;
  @Input() selectMode: 'single' | 'multi' = 'multi'; // Default to multi-select
  filteredItems = [...this.filterToAdd];

  @Input() isDropdownDisabled: boolean = false; // To disable the entire dropdown
  @Input() isSearchBoxDisabled: boolean = false; // Default to false (enabled)

  constructor(private eRef: ElementRef) {}

  // Toggle dropdown visibility only if the dropdown is not disabled
  toggleDropdown() {
    if (this.isDropdownDisabled) {
      return; // Prevent dropdown from opening if it's disabled
    }
    this.dropdownOpen = !this.dropdownOpen;
  }

  // Update filtered list based on search query
  onSearch(query: string) {
    if (this.isSearchBoxDisabled) {
      return; // Skip the search logic if the search box is disabled
    }
    this.searchQuery = query;
    this.filteredItems = this.filterToAdd.filter(
      (item) => item.value.toLowerCase().includes(query.toLowerCase()) // Assuming 'value' is a string
    );
  }

  toggleSelection(item: any) {
    if (item.disabled || this.isDropdownDisabled) {
      return; // Do nothing if the item or dropdown is disabled
    }

    if (this.selectMode === 'multi') {
      const index = this.selectedFilter.findIndex((selected) => selected.value === item.value);
      if (index === -1) {
        this.selectedFilter.push(item);
      } else {
        this.selectedFilter.splice(index, 1);
      }
    } else if (this.selectMode === 'single') {
      this.selectedFilter = [item];
      this.dropdownOpen = false;
    }

    this.selectedFilterChange.emit(this.selectedFilter);
  }

  isSelected(item: any): boolean {
    return this.selectedFilter.some((selected) => selected.value === item.value);
  }

  isSelectAllChecked() {
    return this.selectedFilter.length === this.filteredItems.length;
  }

  toggleSelectAll() {
    if (this.isSelectAllChecked()) {
      this.selectedFilter = [];
    } else {
      this.selectedFilter = [...this.filteredItems.filter((item) => !item.disabled)];
    }
    this.selectedFilterChange.emit(this.selectedFilter);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterToAdd'] && this.filterToAdd) {
      this.filteredItems = [...this.filterToAdd];
    }
  }

  ngOnInit(): void {
    if (!Array.isArray(this.selectedFilter)) {
      this.selectedFilter = [];
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }
}
